import { useCallback, useMemo, useState } from "react";
import { categories, downData, seriesFn } from "../resources/customReportsDTO";
import { TFunction } from "i18next";
import { RowsModel } from "../../../model/insurancePoliciesSummary";

const useUpdateData = (Tl: TFunction) => {
  const [newDownData, setNewDownData] = useState(downData);
  const [dataSeries, setDataSeries] = useState(seriesFn(Tl));
  const [dataCategories, setDataCategories] = useState(categories);

  const updateData = useCallback((responseAllQuote: any) => {
    const filteredPolicy = responseAllQuote.filter(
      (item: RowsModel) => item.catalogStatusQuote?.description === "Emitida",
    );

    const quotedPolicy = responseAllQuote.filter(
      (item: RowsModel) => item.catalogStatusQuote?.description === "Cotizada",
    );

    const salesCount = filteredPolicy.length;
    const quotedPolicyCount = quotedPolicy.length;

    setNewDownData((prevData) =>
      prevData.map((card) => {
        switch (card.id) {
          case "1":
            return {
              ...card,
              numericalTitle: quotedPolicyCount.toString(),
            };
          case "2":
            return { ...card, numericalTitle: salesCount.toString() };

          default:
            return card;
        }
      }),
    );

    //LLENA LA DATA DEL CHART

    const productCount: {
      [key: string]: {
        description: string;
        countsByStatus: { [status: string]: number };
      };
    } = {};

    responseAllQuote.forEach((item: RowsModel) => {
      const productId = item?.productId?.id;
      const description = item?.productId?.description;
      const status = item?.catalogStatusQuote?.description;

      if (!productCount[productId]) {
        productCount[productId] = {
          description,
          countsByStatus: {},
        };
      }

      if (productCount[productId].countsByStatus[status]) {
        productCount[productId].countsByStatus[status] += 1;
      } else {
        productCount[productId].countsByStatus[status] = 1;
      }
    });

    const sortedProducts = Object.keys(productCount)
      .map((key) => {
        const product = productCount[key];
        const totalCount = Object.values(product.countsByStatus).reduce(
          (sum, count) => sum + count,
          0,
        );
        return { ...product, id: key, totalCount };
      })
      .sort((a, b) => b.totalCount - a.totalCount);

    const top5Products = sortedProducts.slice(0, 5);
    const issuedData = top5Products.map(
      (product) => product.countsByStatus["Emitida"] || 0,
    );
    const listedData = top5Products.map(
      (product) => product.countsByStatus["Cotizada"] || 0,
    );
    const categoriesData = top5Products.map((product) => product.description);

    setDataSeries((prevSeries: any) => {
      return [
        {
          ...prevSeries[0],
          data: issuedData,
        },
        {
          ...prevSeries[1],
          data: listedData,
        },
      ];
    });
    setDataCategories(categoriesData);
  }, []);

  return useMemo(
    () => ({
      newDownData,
      dataSeries,
      dataCategories,
      updateData,
    }),
    [newDownData, dataSeries, dataCategories, updateData],
  );
};

export default useUpdateData;
